module.exports = require("./ff-Adlm-GH.d.ts");